import { Controller } from 'react-hook-form';
import { FormFeedback } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { DatePicker } from 'components/date-picker';
import { s } from 'utilities/strings';

import { useGiftAmountConfiguration } from './hooks';

const EndDate = () => {
  const { control, errors } = useGiftAmountConfiguration();

  return (
    <Controller
      control={control}
      name="giftDateEnd"
      render={({ field: { onChange, value } }) => (
        <>
          <DatePicker
            className={classNames({
              'is-invalid': get(errors, 'giftDateEnd.type') === 'custom',
            })}
            onChange={(value) => onChange(value)}
            onClear={() => onChange(null)}
            placeholderText={s(['Site.End', 'Site.Date'])}
            selected={value}
          />
          <FormFeedback type="invalid">{get(errors, 'giftDateEnd.message')}</FormFeedback>
        </>
      )}
    />
  );
};

export default EndDate;
